import { UserMenu } from '../auth/user-menu';
import { CreditsPill } from '../credits/credits-pill';
import { BrandLockup } from '../marketing/brand-lockup';

/**
 * Home's top bar: the Floto Rooms wordmark on the left, credits and the
 * account on the right, floating as a white bar over the page. No workspace
 * switcher — Floto Rooms is personal plans only for now.
 */
export function HomeHeader() {
  return (
    <header className="mx-auto flex h-16 w-full max-w-[1360px] items-center justify-between rounded-bar bg-surface px-3.5 shadow-bar">
      <BrandLockup className="ml-3" />
      <div className="flex items-center gap-3">
        <CreditsPill />
        <UserMenu />
      </div>
    </header>
  );
}
